import { call, put } from 'redux-saga/effects'
import { apiConfig } from '../../../../../config/api-config'
import { makeAccess } from '../../../../../config/factory-controller'
import { JourneyRepository } from '../../../data/repositories/journey-repository'
import type { Journey, JourneyRequest } from '../../../domain/models/journey'
import { JourneyService } from '../../../service/journey-service'
import { JourneyController } from '../../controllers/journey-controller'
import * as action from '../actions/journey-actions'

export const createJourneyController = async (payload: JourneyRequest) => {
  const { key, token } = await makeAccess()
  const dataSource = new JourneyService(apiConfig(key, token))
  const repository = new JourneyRepository(dataSource)
  const control = new JourneyController(repository)
  const result = await control.createJourney(payload)
  
  return result
}

export function* createJourneySaga({ payload }: any): any {
  try {
    const result: Journey = yield call(createJourneyController, payload)
    yield put(action.createJourneySuccess(result))
  } catch (error: any) {
    yield put(action.createJourneyError(error.toString()))
  }
}